interface OTPHook {
  verificationCode: string;
  authID: string | null;
  userEmail: string | null;
  otpErrorMessage: string;
  setValidationError: (error: string) => void;
  handleCloseDrawer: () => void;
  clearVerificationCode: () => void;
  setOTPDisabled: (disabled: boolean) => void;
  requestNewCodeWithChannel: (channel: string) => void;
}

interface OTPDrawerContent {
  buttonsConfig: {
    inline: { channel: string };
    separate?: { channel: string };
  };
}

interface UseScanToPayHandlersProps {
  onClose: () => void;
  otpHook: OTPHook;
  otpDrawerContent: OTPDrawerContent;
}

export const useScanToPayHandlers = ({
  onClose,
  otpHook,
  otpDrawerContent
}: UseScanToPayHandlersProps) => {

  const handleInlineButtonClick = () => {
    otpHook.requestNewCodeWithChannel(otpDrawerContent.buttonsConfig.inline.channel);
  };

  const handleSeparateButtonClick = () => {
    if (otpDrawerContent.buttonsConfig.separate) {
      otpHook.requestNewCodeWithChannel(otpDrawerContent.buttonsConfig.separate.channel);
    }
  };

  const handleCloseDrawer = () => {
    // Clear verification code when drawer closes
    otpHook.clearVerificationCode();
    // Clear any validation errors
    otpHook.setValidationError('');
    // Call the parent's onClose handler
    onClose();
  };

  return {
    handleInlineButtonClick,
    handleSeparateButtonClick,
    handleCloseDrawer
  };
};
